app.service('search',function(searchHistory, cookie, loading, modal){

	function emptyKeyword(){							// do poprawy
		modal.alert('Proszę wpisać szukaną frazę');
	}
	function goToSearchPage(value){
		var url=document.location.host;
		if(document.location.protocol !== ''){
			url = document.location.protocol+ '//' + url;
		}
		
		let testAB = cookie.get('searchTestAB');
		if(testAB === 'G'){
			url += '/search2';
		} else if(testAB === 'P'){
			url += '/search3';
		} else {
			url +='/search';
		}
		url += '.bhtml?keyword=' + encodeURIComponent(value);
		loading.start();
		document.location.href=url;
	}
	function search(q) {
		var value = $.trim(q);
		if (value.length < 1){
			emptyKeyword();
			return;
		}
		if (searchHistory.enabled()) {
			var obj = {};
			obj[value] = {link: ""};
			searchHistory.add(obj);
		}
		goToSearchPage(value);
	}
	return {
		search
	};
});
